import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_outline_button = _resolveComponent("outline-button")!
  const _component_sale_prices_form = _resolveComponent("sale-prices-form")!
  const _component_add_surcharge_modal = _resolveComponent("add-surcharge-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_sale_prices_form, {
      isSurcharges: "",
      "weight-brackets": new Set<number>([0]),
      "sale-prices-rows": _ctx.surchargesRows,
      "gross-margin-mutation": _ctx.grossMarginMutation
    }, {
      "extra-actions": _withCtx(() => [
        _createVNode(_component_outline_button, {
          class: "ml-2",
          type: "outline",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAddSurchargeModal = true))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" + Add Surcharge ")
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["sale-prices-rows", "gross-margin-mutation"]),
    _createVNode(_component_add_surcharge_modal, {
      modelValue: _ctx.showAddSurchargeModal,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showAddSurchargeModal) = $event)),
      "proposal-id": _ctx.proposalId
    }, null, 8, ["modelValue", "proposal-id"])
  ], 64))
}